import { useTranslation } from "@redotech/redo-i18n";
import { RedoExternalLink } from "@redotech/redo-web/arbiter-components/links/redo-external-link";
import { memo } from "react";

export const WithdrawalExclusionDetails = memo(
  function WithdrawalExclusionDetails() {
    const { t } = useTranslation();
    const url = `${window.location.href.split("/settings")[0]}/settings/withdrawals`;
    return <RedoExternalLink text={t("Withdrawal settings")} url={url} />;
  },
);
